'use strict';

var processInclude = require('base/util');
const { queryAll, queryFirst } = require('./domUtil');
document.addEventListener('DOMContentLoaded', () => {
    processInclude(require('./contactUs/contactUs'));

    const faqContainer = queryFirst('.customer-service div.faq');
    if (faqContainer) {
        const faqElements = queryAll('.card-header.question', faqContainer);
        const faqList = [];
        faqElements.forEach(faqElement => {
            const question = queryFirst('.btn-link', faqElement).innerText.replace(/\s\s+/g, ' ')
            const questionFormatted = question.substring(0, question.indexOf('?') + 1);
            const answer = queryFirst('.card-body .content', faqElement).innerText;
            faqList.push({
                "@type": "Question",
                "name": questionFormatted,
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": answer
                }
            });
        });
        const faqScriptObject = {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": faqList
        }
        const faqScriptElement = document.createElement("script");
        faqScriptElement.id = "faqScript";
        faqScriptElement.type = "application/ld+json";
        faqScriptElement.innerHTML = JSON.stringify(faqScriptObject);
        document.head.appendChild(faqScriptElement);
    }
});

// Trim the input on the first and last name fields to prevent users from submitting whitespace
$('#contact-first-name, #contact-last-name').on('blur', function() {
    this.value = this.value.trim();
});
